import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {MultiselectComponent, FilterPipe} from "./multiselect.component";
import {ReactiveFormsModule} from "@angular/forms";
import {ClickOutsideDirective} from "./click-outside.directive";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
	imports: [
	    CommonModule,
        ReactiveFormsModule,
        TranslateModule
    ],
	declarations: [
        MultiselectComponent,
        FilterPipe,
        ClickOutsideDirective
	],
	exports: [
        MultiselectComponent,
        FilterPipe,
        ClickOutsideDirective,
        TranslateModule
	]
})
export class MultiselectModule {}